import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import LogoMetro from "./LogoGAM_fond_blanc.png"

import {MainComponent} from "./views/mainComponent";


const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
        <BrowserRouter>

            <Routes>
                <Route>
                    <Route path="*" element={<MainComponent/>}/>
                </Route>
            </Routes>
            <div className='Header-metro-alec'>
                <div className='Logos-metro-alec'>
                    <a href="https://www.grenoblealpesmetropole.fr" target="_blank">
                        <img className='logoMetro' src={LogoMetro}/></a>
                    <span>&</span>
                    <a href="https://www.alec-grenoble.org" target="_blank">
                        <img className='logoAlec'
                         src='https://www.alec-grenoble.org/uploads/alec38_calculatrice/img/ALEC.png'/>
                    </a>
                </div>
                <p className='footer-info'>L'outil Bingo Réno a été développé par <a href="https://www.grenoblealpesmetropole.fr" target="_blank">Grenoble Alpes Métropole</a> et l'<a href="https://www.alec-grenoble.org" target="_blank">Agence Locale de l'Énergie et du Climat</a></p>
            </div>
        </BrowserRouter>
    </React.StrictMode>
);


reportWebVitals();

